LogoValidator.$inject = ['validator'];

export default function LogoValidator(validator) {
	const instance = new validator();
	instance.ruleFor('code').notEmpty().withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('code').lengthBetweenValues(0, 15).withMessage('VALIDATION_TOO_LONG_DESCRIPTION');
	instance.ruleFor('libelle').notEmpty().withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('libelle').lengthBetweenValues(0, 100).withMessage('VALIDATION_TOO_LONG_DESCRIPTION');
	instance.ruleFor('downloadFile').fileTooBig(2000000).withMessage('FILE_TOO_LARGE');

	return instance;
}
